
document.addEventListener('DOMContentLoaded', function () {
	AOS.init();
});

if (Shopify.designMode) {
	document.addEventListener('shopify:section:load', function () {
		AOS.refreshHard();
	});

	document.addEventListener('shopify:section:unload', function () {
		AOS.refreshHard();
	});

	document.addEventListener('shopify:section:select', function () {
		AOS.refreshHard();
	});

	document.addEventListener('shopify:section:deselect', function () {
		AOS.refreshHard();
	});

	document.addEventListener('shopify:block:select', function () {
		AOS.refreshHard();
	});

	document.addEventListener('shopify:block:deselect', function () {
		AOS.refreshHard();
	});
}


gsap.registerPlugin(MorphSVGPlugin);

function parseLiquidJson(input) {
  try {
    // Decode HTML entities
    const decoded = input.replace(/&quot;/g, '"')
                         .replace(/=&gt;/g, ':')
    const parsed = JSON.parse(decoded);
    return parsed;
  } catch (error) {
    console.error('Error parsing the string:', error);
    return null;
  }
}


function useShopSettings() {
	return {
		money_with_currency_format: document.head.querySelector("[name=money_format]").content || ""
	}
}

function useSectionLocale(key, json) {
	window.omikuji.t[key] = parseLiquidJson(json);
}

function useOmikujiGlobals() {
	return {
		__eventBus: new Comment('omikuji-event-bus'),
		t: {
			general: parseLiquidJson("{\u0026quot;add_to_cart\u0026quot; =\u0026gt; \u0026quot;Ajouter au panier\u0026quot;, \u0026quot;i_m_adding_to_cart\u0026quot; =\u0026gt; \u0026quot;J\u0026#39;ajoute au panier\u0026quot;, \u0026quot;footer\u0026quot; =\u0026gt; {\u0026quot;headline\u0026quot; =\u0026gt; \u0026quot;Les dernières tendances du Japon et vos cartes de collection préférées, expédiées depuis la France !\u0026quot;}, \u0026quot;product_card\u0026quot; =\u0026gt; {\u0026quot;new\u0026quot; =\u0026gt; \u0026quot;Nouveau\u0026quot;, \u0026quot;back_in_stock\u0026quot; =\u0026gt; \u0026quot;Retour en stock\u0026quot;, \u0026quot;low_stock\u0026quot; =\u0026gt; \u0026quot;Stock limité\u0026quot;}, \u0026quot;out_of_stock\u0026quot; =\u0026gt; \u0026quot;Épuisé\u0026quot;, \u0026quot;description\u0026quot; =\u0026gt; \u0026quot;Description\u0026quot;, \u0026quot;home\u0026quot; =\u0026gt; \u0026quot;Accueil\u0026quot;, \u0026quot;an_error_occured\u0026quot; =\u0026gt; \u0026quot;Une erreur est survenue\u0026quot;, \u0026quot;password_page\u0026quot; =\u0026gt; {\u0026quot;login_form_heading\u0026quot; =\u0026gt; \u0026quot;Accéder à la boutique à l\u0026#39;aide d\u0026#39;un mot de passe :\u0026quot;, \u0026quot;login_password_button\u0026quot; =\u0026gt; \u0026quot;Saisir avec un mot de passe\u0026quot;, \u0026quot;login_form_password_label\u0026quot; =\u0026gt; \u0026quot;Mot de passe\u0026quot;, \u0026quot;login_form_password_placeholder\u0026quot; =\u0026gt; \u0026quot;Votre mot de passe\u0026quot;, \u0026quot;login_form_error\u0026quot; =\u0026gt; \u0026quot;Mot de passe incorrect !\u0026quot;, \u0026quot;login_form_submit\u0026quot; =\u0026gt; \u0026quot;Saisir\u0026quot;, \u0026quot;admin_link_html\u0026quot; =\u0026gt; \u0026quot;La boutique vous appartient-elle ? \u0026lt;a href=\\\u0026quot;\/admin\\\u0026quot; class=\\\u0026quot;link underlined-link\\\u0026quot;\u0026gt;Se connecter ici\u0026lt;\/a\u0026gt;\u0026quot;, \u0026quot;powered_by_shopify_html\u0026quot; =\u0026gt; \u0026quot;Cette boutique sera propulsée par {{ shopify }}\u0026quot;}, \u0026quot;social\u0026quot; =\u0026gt; {\u0026quot;alt_text\u0026quot; =\u0026gt; {\u0026quot;share_on_facebook\u0026quot; =\u0026gt; \u0026quot;Partager sur Facebook\u0026quot;, \u0026quot;share_on_twitter\u0026quot; =\u0026gt; \u0026quot;Partager sur X\u0026quot;, \u0026quot;share_on_pinterest\u0026quot; =\u0026gt; \u0026quot;Épingler sur Pinterest\u0026quot;}, \u0026quot;links\u0026quot; =\u0026gt; {\u0026quot;twitter\u0026quot; =\u0026gt; \u0026quot;X (Twitter)\u0026quot;, \u0026quot;facebook\u0026quot; =\u0026gt; \u0026quot;Facebook\u0026quot;, \u0026quot;pinterest\u0026quot; =\u0026gt; \u0026quot;Pinterest\u0026quot;, \u0026quot;instagram\u0026quot; =\u0026gt; \u0026quot;Instagram\u0026quot;, \u0026quot;tumblr\u0026quot; =\u0026gt; \u0026quot;Tumblr\u0026quot;, \u0026quot;snapchat\u0026quot; =\u0026gt; \u0026quot;Snapchat\u0026quot;, \u0026quot;youtube\u0026quot; =\u0026gt; \u0026quot;YouTube\u0026quot;, \u0026quot;vimeo\u0026quot; =\u0026gt; \u0026quot;Vimeo\u0026quot;, \u0026quot;tiktok\u0026quot; =\u0026gt; \u0026quot;TikTok\u0026quot;}}, \u0026quot;continue_shopping\u0026quot; =\u0026gt; \u0026quot;Continuer les achats\u0026quot;, \u0026quot;pagination\u0026quot; =\u0026gt; {\u0026quot;label\u0026quot; =\u0026gt; \u0026quot;Pagination\u0026quot;, \u0026quot;page\u0026quot; =\u0026gt; \u0026quot;Page {{ number }}\u0026quot;, \u0026quot;next\u0026quot; =\u0026gt; \u0026quot;Page suivante\u0026quot;, \u0026quot;previous\u0026quot; =\u0026gt; \u0026quot;Page précédente\u0026quot;}, \u0026quot;search\u0026quot; =\u0026gt; {\u0026quot;search\u0026quot; =\u0026gt; \u0026quot;Recherche\u0026quot;, \u0026quot;reset\u0026quot; =\u0026gt; \u0026quot;Effacer le terme de recherche\u0026quot;}, \u0026quot;cart\u0026quot; =\u0026gt; {\u0026quot;view\u0026quot; =\u0026gt; \u0026quot;Voir le panier ({{ count }})\u0026quot;, \u0026quot;item_added\u0026quot; =\u0026gt; \u0026quot;Article ajouté au panier\u0026quot;, \u0026quot;view_empty_cart\u0026quot; =\u0026gt; \u0026quot;Voir le panier\u0026quot;}, \u0026quot;share\u0026quot; =\u0026gt; {\u0026quot;copy_to_clipboard\u0026quot; =\u0026gt; \u0026quot;Copier le lien\u0026quot;, \u0026quot;share_url\u0026quot; =\u0026gt; \u0026quot;Lien\u0026quot;, \u0026quot;success_message\u0026quot; =\u0026gt; \u0026quot;Lien copié dans le presse-papiers\u0026quot;, \u0026quot;close\u0026quot; =\u0026gt; \u0026quot;Fermer le partage\u0026quot;}, \u0026quot;slider\u0026quot; =\u0026gt; {\u0026quot;of\u0026quot; =\u0026gt; \u0026quot;de\u0026quot;, \u0026quot;next_slide\u0026quot; =\u0026gt; \u0026quot;Faire glisser vers la droite\u0026quot;, \u0026quot;previous_slide\u0026quot; =\u0026gt; \u0026quot;Faire glisser vers la gauche\u0026quot;, \u0026quot;name\u0026quot; =\u0026gt; \u0026quot;Carrousel\u0026quot;}}")
		},
		shopSettings: useShopSettings(),
		editorReloadPersist: new Object()
	}
}

window.omikuji = useOmikujiGlobals()

function omikujiAddToCart(e) {
		const formData = new FormData();
		const dataId = event.target.getAttribute('data-id');
		formData.append('id', dataId);
		formData.append('quantity', '1');

		fetch('/cart/add', {
			method: 'POST',
			body: formData,
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		}).then((response) => {
			publish(OmikujiEvents.ADDTOCART, {
				product: props.product,
				variant: displayedVariant.value,
			});
		})
	}